import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [ 'menu', 'button' ];

  connect() {
    // console.log('Header controller connected');
  }

  toggle() {
    this.element.classList.toggle('is-open');
    const expanded = this.buttonTarget.getAttribute('aria-expanded') === 'true' || false;
    this.buttonTarget.setAttribute('aria-expanded', !expanded);
  }
}
